import { Modal, Button, Form } from "react-bootstrap";
import ImageWithLoader from "../components/image";

export default function DeleteProductModal({
  show,
  handleClose,
  product = {},
  onDelete,
  deleting = false,
}) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Бараа устгах</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">Энэ барааг устгахад итгэлтэй байна уу?</p>

        <div className="d-flex align-items-center mb-3">
          <ImageWithLoader
            src={product.image}
            alt={product.name}
            width="60px"
            height="60px"
            className="me-3 rounded"
          />
          <div>
            <div>
              <strong>{product.name}</strong>
            </div>
            <div>Үнэ: {product.price}₮</div>
            <div>Үлдэгдэл: {product.quantity}</div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={deleting}>
          Болих
        </Button>
        <Button variant="danger" onClick={onDelete} disabled={deleting}>
          {deleting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Устгаж байна...
            </>
          ) : (
            "Устгах"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
